// extracted by mini-css-extract-plugin
export default {"container":"vocabulary_container__RIK1x","programsContent":"vocabulary_programsContent__X3kaq"};